import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { CreativePreviewModal } from '@features/campaigns/builder/components/FormFields/common/CreativePreviewModal/CreativePreviewModal';
import { FileItemTemplate } from '@features/campaigns/builder/components/FormFields/common/FileUpload/components/FileItemTemplate/FileItemTemplate.tsx';
import { CreativeCategory, CreativeType } from '@features/campaigns/builder/types/creativeType.ts';
import { i18nNameSpace } from '@shared/consts/i18n.ts';

interface CreativePreviewProps {
  creativeUrl: string;
  fileName?: string;
  creativeType: CreativeType;
  creativeCategory: CreativeCategory;
  headerText: string;
}

export function CreativePreview({
  creativeUrl,
  fileName,
  creativeType,
  headerText,
  creativeCategory,
}: CreativePreviewProps) {
  const { t } = useTranslation(i18nNameSpace.CAMPAIGNS);
  const [isPreviewModalVisible, setIsPreviewModalVisible] = useState(false);
  const currentFileName = fileName || 'builder.formFields.common.currentCreativeFile';

  const handleToggleModalVisibility = () => setIsPreviewModalVisible(!isPreviewModalVisible);

  return (
    <div>
      <FileItemTemplate
        fileName={t(currentFileName)}
        fileURL={creativeUrl}
        fileFormatSize={''}
        creativeCategory={creativeCategory}
        togglePreviewModal={handleToggleModalVisibility}
        canDeleteFile={true}
      />
      <CreativePreviewModal
        isModalVisible={isPreviewModalVisible}
        toggleModalVisibility={handleToggleModalVisibility}
        creativeUrl={creativeUrl}
        creativeType={creativeType}
        headerText={headerText}
      />
    </div>
  );
}
